<style lang="scss" scoped>
  .DrawerItems {
  }
</style>

<template lang="pug">
  .DrawerItems
    .DrawerItems__item(v-for="item in items")
      component(:is="item.component",
      v-bind="item.props",
      @data="item.onData ? item.onData($event) : onData($event)",
      @remove="item.onRemove ? item.onRemove($event) : onRemove($event)")
</template>

<script>
  /**
   * This uses the dynamic components concept in Vue and renders the components provided to it
   * as the props.items
   */
  export default {
    name: 'DrawerItems',

    props: {
      items: {
        type: Array,
        required: true,
      },
    },

    methods: {
      onData() {
      },
      onRemove() {
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AppDrawer/components/DrawerItems.vue